import React from 'react';
import { services } from '../constants';
import TireChangeStore from '../tire-change-store';
import { Actions } from '../actions';

const LicenseNumberInput = ({ value }) => {
    return (
        <div className="licence-number-input">
            <label>Rekisterinumero:</label>
            <input
                type="text"
                placeholder="ABC-123"
                value={value || ''}
                onChange={e => Actions.setLicenseNumber(e.target.value)}
            />
        </div>
    );
};

const Service = ({ service, onSelect, selected }) => {
    const { name, price, icon } = service,
        iconUrl = `/static/nettivanne/webshop/img/tire-change/${icon}.svg`;
    return (
        <div className={`service-box ${selected ? 'selected' : ''}`} onClick={() => onSelect()}>
            <img src={iconUrl} />
            <span className="name">{name}</span>
            <span className="prize">{price} €</span>
        </div>
    )
};

const ServiceSelect = ({ value }) => {
    return (
        <div className="service-select">
            <label>Valitse autotyyppi:</label>
            <div className="options">
                {services.map(s => (
                    <Service
                        key={s.id}
                        service={s}
                        selected={value == s.id}
                        onSelect={() => {
                            Actions.setSelectedService(s.id);
                            $.get(`/_ajax/webshop/shops_for_service/${s.id}`, ({shops}) => {
                                Actions.setShops(shops);
                            });
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

const HotelChoice = ({ value }) => {
    return (
        <div className="hotel-choice">
            <h3>Jätetäänkö renkaat meille säilytykseen?</h3>
            <p>Rengashotellissamme renkaasi ovat parhaassa säilössä. Pesemme ja tarkastamme meillä olevat renkaanne ja saat raportin renkaiden kunnosta sähköpostiisi aina ennen seuraavaa allelaittoa.</p>
            <p>Sinun ei myöskään tarvitse huolehtia ajanvarauksesta – lähetämme vaihtoaikaehdotuksen hyvissä ajoin joka kevät ja syksy.</p>
            <p>Lue lisää rengashotellipalvelustamme <a target="_blank" href="https://rengasturku.fi/rengashotelli/">täältä</a>. Hinnaston löydät <a target="_blank" href="https://rengasturku.fi/tyohinnasto/#tablepress-5-name">täältä</a> (sivun alaosasta). Kausihinta alkaen 88 €.</p>
            <div className="hotel-box">
                <input
                    type="checkbox"
                    checked={value}
                    onChange={() => Actions.setHotel(!value)}
                />
                <div>
                    <span><b>Jätän renkaat säilytykseen</b></span>
                    <span><small>Maksetaan vasta kauden jälkeen</small></span>
                </div>
            </div>
        </div>
    );
};

class CarInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...TireChangeStore.getAll(),
        }
        this.update = this.update.bind(this);
    }
    update() {
        this.setState(TireChangeStore.getAll());
    }
    componentDidMount() {
        TireChangeStore.addChangeListener(this.update);
    }
    componentWillUnmount() {
        TireChangeStore.removeChangeListener(this.update);
    }
    render() {
        const { hotel, licenseNumber, selectedService, shops } = this.state;
        return (
            <section className="car-info">
                <h2>1. Auton tiedot</h2>
                <LicenseNumberInput value={licenseNumber} />
                <ServiceSelect value={selectedService} shops={shops}/>
                <HotelChoice value={hotel} />
            </section>
        );
    }
}

export default CarInfo;


/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-change/components/CarInfo.js
 **/